<span class="material-symbols-outlined dialog__icon">waving_hand</span>

<div class="row">
    <div class="col-12 section__header text-center">
    @if (timeInHours < 12){
    <h2 mat-dialog-title>GOOD MORNING {{data.therapistDetail.firstName |uppercase}}</h2>  
}
@else if (timeInHours > 17){
    <h2 mat-dialog-title>GOOD EVENING {{data.therapistDetail.firstName | uppercase}}</h2>  

} @else{
    <h2 mat-dialog-title>GOOD AFTERNOON {{data.therapistDetail.firstName | uppercase}}</h2>  

}
<p>Clock in to get started</p>
    </div>

</div>
<button class="w-100" [mat-dialog-close]="true" mat-flat-button color="primary">CLOCK IN</button>